import { Component } from "@angular/core";
import { DialogService } from "../../bootstrap-modal/dialog.service";
import { DialogComponent } from "../../bootstrap-modal/dialog.component";


export type SearchSoldToOtherCountriesHelpDialogModel = {
  property: string;
  examples: string[];
};

export type SearchSoldToOtherCountriesDialogModel = {
  searchOptions: SearchSoldToOtherCountriesHelpDialogModel[];
};

export interface SoldToOtherCountriesSearchModel { }

@Component({
  templateUrl: "./search-soldto-in-other-countries-info.template.pug",
  providers: [
  ],
})
export class SearchSoldtoInOtherCountriesInfoComponent extends DialogComponent<SoldToOtherCountriesSearchModel, any>
  implements SoldToOtherCountriesSearchModel {

  constructor(public dialogService: DialogService) {
    super(dialogService);
  }

  public static show(dialogService: DialogService, model: SoldToOtherCountriesSearchModel): void {
    dialogService.addDialog(SearchSoldtoInOtherCountriesInfoComponent, model, { backdropColor: "rgba(0, 0, 0, 0.5)" });
  }

  cancel(): void {
    this.result = null;
    this.close();
  }
}